/* eslint-disable no-eval */
import formUtils from './formUtils'
import Vue from 'vue'
import bus from './eventBus'
import generateUtils from './generateUtils'
/**
 * 组件解析工具
 */
export default class moduleUtils {
  static generateFormModel(genList, value, models, rules, type) {
    for (let i = 0; i < genList.length; i++) {
      if (genList[i].type === 'grid') {
        // 栅格组件
        genList[i].columns.forEach(item => {
          this.generateFormModel(item.list, value, models, rules)
        })
      } else if (genList[i].type === 'report') {
        // 中国式表格
        genList[i].rows.forEach(row => {
          row.columns.forEach(column => {
            if (column.list && column.list.length > 0) {
              this.generateFormModel(column.list, value, models, rules, type)
            }
          })
        })
      } else {
        if (
          value &&
          Object.prototype.hasOwnProperty.call(value, genList[i].model)
        ) {
          models[genList[i].model] = value[genList[i].model]
        } else {
          // 排除分割线 文本 按钮
          const excluedsType = ['divider', 'swtext', 'button']
          const numberType = ['rate', 'slider']
          const arrayType = ['page', 'file', 'imgupload', 'checkbox']
          if (!excluedsType.includes(genList[i].type)) {
            if (genList[i].type === 'sonform') {
              if (type === 'preview') {
                genList[i].sonValues = []
                genList[i].tableLists = []
              }

              models[genList[i].model] = genList[i].sonValues
            } else if (genList[i].options.value) {
              if (genList[i].type === 'page' && type === 'preview') {
                genList[i].options.value = []
              }
              models[genList[i].model] = JSON.parse(
                JSON.stringify(genList[i].options.value)
              )
            } else if (arrayType.includes(genList[i].type)) {
              const defaultValue = genList[i].options.defaultValue
              models[genList[i].model] = Array.isArray(defaultValue)
                ? defaultValue
                : []
            } else if (numberType.includes(genList[i].type)) {
              models[genList[i].model] = genList[i].options.defaultValue
                ? genList[i].options.defaultValue
                : 0
            } else if (genList[i].type === 'comment') {
              models[genList[i].model] = []
            } else if (genList[i].type === 'address') {
              // 当为地址时，model的值
              models[genList[i].model] = { selectValue: [], inputValue: '' }
            } else if (genList[i].type === 'location') {
              // 当为定位时，model的值
              models[genList[i].model] = { formatted_address: '' }
            } else if (genList[i].type === 'user') {
              if (genList[i].options.multiple) {
                models[genList[i].model] = []
              } else {
                models[genList[i].model] = ''
              }
            } else {
              // 没有值，第一次加载，设置内置对象
              const defaultValue = genList[i].options.defaultValue
              if (defaultValue || defaultValue === 0) {
                models[genList[i].model] = defaultValue
              } else {
                models[genList[i].model] = ''
              }
            }
          }
        }
        try {
          if (genList[i].type === 'address') {
            if (rules[genList[i].model + '.selectValue']) {
              rules[genList[i].model] = {
                selectValue: [
                  ...rules[genList[i].model + '.selectValue'],
                  ...genList[i].rules.map(item => {
                    if (item.pattern) {
                      return { ...item, pattern: eval(item.pattern) }
                    } else {
                      return { ...item }
                    }
                  }),
                ],
              }
            } else {
              rules[genList[i].model] = {
                selectValue: [
                  ...genList[i].rules.map(item => {
                    if (item.pattern) {
                      return { ...item, pattern: eval(item.pattern) }
                    } else {
                      return { ...item }
                    }
                  }),
                ],
              }
            }
          } else if (genList[i].type === 'location') {
            if (rules[genList[i].model + '.formatted_address']) {
              rules[genList[i].model] = {
                formatted_address: [
                  ...rules[genList[i].model + '.formatted_address'],
                  ...genList[i].rules.map(item => {
                    if (item.pattern) {
                      return { ...item, pattern: eval(item.pattern) }
                    } else {
                      return { ...item }
                    }
                  }),
                ],
              }
            } else {
              rules[genList[i].model] = {
                formatted_address: [
                  ...genList[i].rules.map(item => {
                    if (item.pattern) {
                      return { ...item, pattern: eval(item.pattern) }
                    } else {
                      return { ...item }
                    }
                  }),
                ],
              }
            }
          } else if (
            genList[i].type === 'input' &&
            Object.prototype.hasOwnProperty.call(
              genList[i].options,
              'carNumberOptions'
            )
          ) {
            // 车牌组件校验
            let xreg =
              /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/
            let creg =
              /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/
            if (rules[genList[i].model]) {
              rules[genList[i].model] = [
                ...rules[genList[i].model],
                ...genList[i].rules.map(item => {
                  return {
                    // ...item,
                    required: item.required,
                    validator: (rule, value, callback) => {
                      if (value === '') {
                        callback(new Error(genList[i].name + '必须填写'))
                      } else {
                        let flag = false
                        if (value.length === 0) {
                          callback(new Error(genList[i].name + '必须填写'))
                        }
                        if (value.length === 7) {
                          flag = creg.test(value)
                        } else if (value.length === 8) {
                          flag = xreg.test(value)
                        }
                        if (flag) {
                          callback()
                        } else {
                          callback(new Error(`请输入正确的${genList[i].name}`))
                        }
                      }
                    },
                  }
                }),
              ]
            } else {
              rules[genList[i].model] = [
                ...genList[i].rules.map(item => {
                  return {
                    // ...item,
                    required: item.required,
                    validator: (rule, value, callback) => {
                      if (value === '') {
                        callback(new Error(genList[i].name + '必须填写'))
                      } else {
                        let flag = false
                        if (value.length === 0) {
                          callback(new Error(genList[i].name + '必须填写'))
                        }
                        if (value.length === 7) {
                          flag = creg.test(value)
                        } else if (value.length === 8) {
                          flag = xreg.test(value)
                        }
                        if (flag) {
                          callback()
                        } else {
                          callback(new Error(`请输入正确的${genList[i].name}`))
                        }
                      }
                    },
                  }
                }),
              ]
            }
          } else {
            if (rules[genList[i].model]) {
              rules[genList[i].model] = [
                ...rules[genList[i].model],
                ...genList[i].rules.map(item => {
                  if (item.pattern) {
                    return { ...item, pattern: eval(item.pattern) }
                  } else {
                    return { ...item }
                  }
                }),
              ]
            } else {
              rules[genList[i].model] = [
                ...genList[i].rules.map(item => {
                  console.log(item, 'item')
                  if (item.pattern) {
                    return { ...item, pattern: eval(item.pattern) }
                  } else {
                    return { ...item }
                  }
                }),
              ]
            }
          }
        } catch (error) {
          console.log(error)
        }
      }
    }
  }

  static changeWidget(list, widget, eventName) {
    if (!list) {
      return
    }
    // console.log(list, widget, eventName, 8111)
    list.forEach(item => {
      if (item.type === 'grid') {
        item.columns.forEach(ctem => {
          this.changeWidget(ctem.list, widget, eventName)
        })
      } else if (item.type === 'sonform') {
        if (
          eventName &&
          eventName.indexOf('change') < 0 &&
          item.model === widget.model
        ) {
          window.globalBus.$emit(eventName, item)
        }
        if (
          eventName &&
          eventName === 'changeOptions' &&
          item.model === widget.model
        ) {
          const targetOptions = item.options
          const sourceOptions = widget.options
          const options = Object.assign(targetOptions, sourceOptions)
          Vue.set(item, 'options', options)
        }
        this.changeWidget(item.list, widget, eventName)
      } else {
        if (item.model === widget.model) {
          console.log(item.model, widget.model)
          console.log(
            eventName &&
              eventName.indexOf('change') < 0 &&
              item.type !== 'sonform'
          )
          if (
            eventName &&
            eventName.indexOf('change') < 0 &&
            item.type !== 'sonform'
          ) {
            window.globalBus.$emit(eventName, item)
          } else {
            const targetOptions = item.options
            const sourceOptions = widget.options
            const options = Object.assign(targetOptions, sourceOptions)
            console.log('kkkkkkkkk', targetOptions, sourceOptions, options)
            Vue.set(item, 'options', options)
          }
        }
      }
    })
  }

  /**
   * 获取表单组件实例 instanceJson
   * @param formInfo  表单信息
   * @param list 组件集合
   */
  static generateModel(formInfo, list) {
    for (let i = 0; i < list.length; i++) {
      if (list[i].type === 'grid') {
        list[i].columns.forEach(item => {
          this.generateModel(formInfo, item.list)
        })
      } else if (list[i].type === 'report') {
        list[i].rows.forEach(item => {
          item.columns.forEach(columnItem => {
            this.generateModel(formInfo, columnItem.list)
          })
        })
      } else {
        if (
          Object.prototype.hasOwnProperty.call(formInfo.value, list[i].model)
        ) {
          formInfo.models[list[i].model] = formInfo.value[list[i].model]
        } else {
          if (list[i].type !== 'divider') {
            if (list[i].type === 'address') {
              formInfo.models[list[i].model] = {
                selectValue: [],
                inputValue: '',
              }
            } else if (
              list[i].type === 'file' ||
              list[i].type === 'imgupload' ||
              list[i].type === 'sonform' ||
              list[i].type === 'page'
            ) {
              formInfo.models[list[i].model] = []
              if (list[i].type === 'page') {
                list[i].options.value = []
              }
            } else {
              formInfo.models[list[i].model] = list[i].options.defaultValue
            }
          }
        }
      }
    }
  }

  // 过滤models中含有的子页面或者子表单含有里的字段,过滤swtext,button,divider，防止数据结构混乱
  static generateDataInstanceJson(models) {
    const modelsObj = Object.assign({}, models)
    const keys = Object.keys(modelsObj).filter(v => {
      return v.indexOf('page') > -1 || v.indexOf('sonform') > -1
    })
    let notOutKeys = []
    keys.forEach(key => {
      if (modelsObj[key].length === 0) {
        return
      }
      const tempObj = modelsObj[key][0]
      notOutKeys = notOutKeys.concat(Object.keys(tempObj))
    })
    notOutKeys.forEach(key => {
      if (modelsObj[key]) {
        delete modelsObj[key]
      }
    })
    this.deleteUnWantedKey(modelsObj)
    return modelsObj
  }

  static deleteUnWantedKey(models) {
    for (const key in models) {
      if (this.unWantedKey(key)) {
        delete models[key]
      }
      if (key.indexOf('page') > -1 || key.indexOf('sonform') > -1) {
        if (!Array.isArray(models[key])) {
          return
        }
        models[key].forEach(v => {
          this.deleteUnWantedKey(v)
        })
      }
    }
  }

  // 不需要的key
  static unWantedKey(key) {
    if (key.indexOf('divider') > -1) {
      return true
    }
    if (key.indexOf('swtext') > -1) {
      return true
    }
    if (key.indexOf('button') > -1) {
      return true
    }
    return false
  }

  /**
   * 返回纯净的结果数据，去除预览的垃圾数据  moduleJson
   * @param widgetForm
   * @returns {{list: Array, config: any}}
   */
  static generateModuleJson(widgetForm) {
    const moduleJson = JSON.parse(JSON.stringify(widgetForm)) // 初始化
    this.handleModuleJson(moduleJson.list)
    return moduleJson
  }

  /**
   * 处理ModuleJson数据
   * @param list
   */
  static handleModuleJson(list) {
    if (Object.prototype.hasOwnProperty.call(list, 'list')) {
      // eslint-disable-next-line no-self-assign
      list = list
    }
    list.forEach(item => {
      if (item.type === 'grid') {
        item.columns.forEach(ctem => {
          this.handleModuleJson(ctem.list)
        })
      } else if (item.type === 'sonform') {
        item.tableLists = []
        item.sonValues = []
        item.lineDetails = []
        this.handleModuleJson(item.list)
      } else if (item.type === 'page') {
        item.tableLists = []
      } else {
        if (
          Object.prototype.hasOwnProperty.call(item, 'options') &&
          item.type !== 'button' &&
          item.type !== 'swtext' &&
          item.type !== 'divider' &&
          item.type !== 'divider'
        ) {
          if (item.type === 'address') {
            item.options.value = { selectValue: [], inputValue: '' }
          } else if (item.type === 'user') {
            item.options.selectLabel = null
            if (item.options.multiple) {
              item.options.value = []
            } else {
              item.options.value = null
            }
          } else {
            item.options.value = null
          }
        }
        if (
          Object.prototype.hasOwnProperty.call(item.options, 'remoteOptions')
        ) {
          // 如果组件有缓存数据属性remoteOptionsCache且属性值为true 则不清空远程数据remoteOptions
          if (
            Object.prototype.hasOwnProperty.call(
              item.options,
              'remoteOptionsCache'
            )
          ) {
            if (!item.options.remoteOptionsCache) {
              item.options.remoteOptions = []
            }
          }
        }
      }
    })
  }

  /**
   * 返回纯净的结果数据，去除远端获取的垃圾数据  moduleJson
   * @param widgetForm
   * @returns {{list: Array, config: any}}
   */
  static generateNoRemoteModuleJson(widgetForm) {
    const moduleJson = JSON.parse(JSON.stringify(widgetForm)) // 初始化
    this.handleNoRemoteModuleJson(moduleJson.list)
    return moduleJson
  }

  /**
   * 生成无远端数据的moduleJson
   * @param list
   */
  static handleNoRemoteModuleJson(list) {
    list.forEach(item => {
      if (item.type === 'grid') {
        item.columns.forEach(ctem => {
          this.handleNoRemoteModuleJson(ctem.list)
        })
      } else if (item.type === 'sonform') {
        this.handleNoRemoteModuleJson(item.list)
      } else if (item.type === 'report') {
        item.rows.forEach(row => {
          row.columns.forEach(column => {
            this.handleNoRemoteModuleJson(column.list)
          })
        })
      } else {
        if (
          Object.prototype.hasOwnProperty.call(item.options, 'remoteOptions')
        ) {
          // 如果组件有缓存数据属性remoteOptionsCache且属性值为true 则不清空远程数据remoteOptions
          if (
            Object.prototype.hasOwnProperty.call(
              item.options,
              'remoteOptionsCache'
            )
          ) {
            if (!item.options.remoteOptionsCache) {
              item.options.remoteOptions = []
            }
          }
        }
      }
    })
  }

  /**
   * 返回各字段的对应label
   * @param widgetForm
   * @returns {{list: Array, config: any}}
   */
  static generateLabelJson(widgetForm, instanceJson) {
    const moduleJson = JSON.parse(JSON.stringify(widgetForm)) // 初始化
    const labelJson = {}
    this.handleLabelJson(moduleJson.list, labelJson, instanceJson)
    return labelJson
  }

  /**
   * 生成labelJson
   * @param list
   */
  static handleLabelJson(list, labelJson, instanceJson) {
    list.forEach(item => {
      const value = instanceJson[item.model]

      if (item.type === 'grid') {
        item.columns.forEach(ctem => {
          this.handleLabelJson(ctem.list, labelJson, instanceJson)
        })
      } else if (item.type === 'sonform' || item.type === 'page') {
        labelJson[item.model] = []
        for (let i = 0; i < value.length; i++) {
          const lineLabel = {}
          const lineList = item.tableLists[i] || item.list
          this.handleLabelJson(lineList, lineLabel, value[i])
          labelJson[item.model].push(lineLabel)
        }
      } else if (item.type === 'comment') {
        labelJson[item.model] = []
        for (let i = 0; i < value.length; i++) {
          const lineLabel = {}
          const lineList = item.list
          this.handleLabelJson(lineList, lineLabel, value[i])
          labelJson[item.model].push(lineLabel)
        }
      } else {
        this.handleLabelItemJson(item, labelJson, value)
      }
    })
  }

  static handleLabelItemJson(widget, labelJson, value) {
    // 1. 取label
    // 单选框 多选框，下拉框级联选择器    当前位置（取地区名）   地区选择，人员选择器，组织机构
    // 2. 取值
    // 单行文本，多行文本,计数器，时间选择器，日期选择器， 评分， 颜色选择器，开关，滑块  编辑器  评阅组件
    // 3. 取值让后端处理
    //  3.1  链接转base64
    //   图片，电子签名
    //  3.2 链接
    //   附件
    const type = widget.type
    let options = []
    switch (type) {
      case 'radio':
      case 'checkbox':
      case 'select':
        options =
          widget.options.optionType !== 'static'
            ? widget.options.remoteOptions
            : widget.options.options

        labelJson[widget.model] = this.handleOptionsLabel(value, options)
        break

      case 'cascader':
      case 'organization':
        labelJson[widget.model] = this.handleCascaderLabel(value, widget)
        break
      case 'address':
        labelJson[widget.model] = this.handleCascaderLabel(
          value.selectValue,
          widget
        )
        break
      case 'user':
        console.log(493, widget.options)
        if (widget.options.useOraganization) {
          labelJson[widget.model] = widget.options.optionsList
            .map(v => v.name)
            .join()
        } else {
          labelJson[widget.model] = widget.options.labels
        }

        break
      case 'location':
        labelJson[widget.model] =
          value.formatted_address || '暂无定位或定位失败'
        break
      case 'time':
      case 'date':
        labelJson[widget.model] = Array.isArray(value) ? value.join('-') : value
        break
      case 'divider':
      case 'button':
      case 'swtext':
        break
      default:
        console.log(512, widget.model, value)
        labelJson[widget.model] = value
    }
  }
  //  'radio' 'checkbox' 'select':

  static handleOptionsLabel(value, options) {
    if (Array.isArray(value)) {
      const labelArr = []
      value.forEach(val => {
        const label = this.getSingleLabel(val, options)
        labelArr.push(label)
      })
      return labelArr.join()
    } else {
      return this.getSingleLabel(value, options)
    }
  }
  static getSingleLabel(value, options) {
    for (let i = 0; i < options.length; i++) {
      if (value === options[i].value) {
        return options[i].label ? options[i].label : options[i].value
      }
    }
    // options中找不到对应label的话直接返回value
    return value
  }
  // 级联
  static handleSingleCascaderLabel(value, options, props, showAllLevels) {
    let curOptions = options
    const labelArr = []
    const { label: propLabel, value: propValue, children: propChildren } = props
    try {
      ;(value || []).forEach(val => {
        const singleItem = this.getSingleItem(val, curOptions, propValue)
        labelArr.push(singleItem[propLabel])
        curOptions = singleItem[propChildren]
      })
    } catch (e) {
      console.log(e)
    }
    if (!showAllLevels) {
      console.log('537')
      return labelArr[labelArr.length - 1]
    }
    return labelArr.join('/')
  }
  static getSingleItem(value, options, propValue) {
    for (let i = 0; i < options.length; i++) {
      if (options[i][propValue] === value) {
        return options[i]
      }
    }
  }
  static handleCascaderLabel(value, widget) {
    console.log(557, widget, widget.model, widget.name, value)
    if (widget.options.multiple) {
      return (value || []).map(val => {
        return this.handleSingleCascaderLabel(
          val,
          widget.options.remoteOptions,
          widget.options.props,
          widget.options.showAllLevels
        )
      })
    } else {
      return this.handleSingleCascaderLabel(
        value,
        widget.options.remoteOptions,
        widget.options.props,
        widget.options.showAllLevels
      )
    }
  }

  /**
   * 返回纯净的结果数据，去除预览的垃圾数据  instanceJson
   * @param models
   * @returns
   */
  static generateInstanceJson(models) {
    const instanceJson = JSON.parse(JSON.stringify(models)) // 初始化
    this.handleInstanceJson(instanceJson)
    return instanceJson
  }

  /**
   * 处理InstanceJson数据
   * @param instanceJson
   */
  static handleInstanceJson(instanceJson) {
    if (instanceJson !== null) {
      for (const key in instanceJson) {
        instanceJson[key] = null
      }
    }
  }

  /**
   * 更新传过来的模板数据时间戳
   * type只要为page 、sonform    他的model 和key就要改
   * @param data
   */
  static updateModuleJson(data, length = 0) {
    if (Object.hasOwnProperty.call(data, 'sonPages')) {
      const sonPages = data.sonPages
      let array = [...data.list]
      for (const ikey in sonPages) {
        this.updateModuleJson(sonPages[ikey], array.length)
        // 若为子页面，则key中的index索引需要叠加
        array = [...sonPages[ikey].list, ...array]
      }
    }
    if (Object.hasOwnProperty.call(data, 'list')) {
      const list = data.list

      list.forEach((item, index) => {
        const number = length ? index + length : index
        const key = String(new Date().getTime()) + String(number)
        switch (item.type) {
          case 'grid':
            item.columns.forEach(ctem => {
              this.updateModuleJson(ctem)
            })
            break
          case 'sonform':
            item.key = key
            item.model = 'sonform_colorful_egg_' + key
            this.updateModuleJson(item)
            break
          case 'page':
            item.key = key
            item.model = 'page_' + key
            this.updateModuleJson(item)
            break
        }
      })
    }
  }

  /**
   * 根据配置项 -- 设置具体配置
   * @param moduleObj
   * @param config
   */
  static editModule(moduleObj, obj, currentUser, fixHiddenDom) {
    if (moduleObj && obj) {
      if (obj.required !== 'none') {
        // 必填
        let isRequired = false
        if (obj.required === 'true') {
          isRequired = true
          moduleObj.options.required = true
        } else if (obj.required === 'false') {
          moduleObj.options.required = false
        }
        if (moduleObj.rules && moduleObj.rules.length > 0) {
          for (let j = 0; j < moduleObj.rules.length; j++) {
            if (
              Object.prototype.hasOwnProperty.call(
                moduleObj.rules[j],
                'required'
              )
            ) {
              if (!moduleObj.options.required) {
                moduleObj.rules.splice(j, 1)
              } else {
                moduleObj.rules[j].required = true
                moduleObj.rules[j].message = moduleObj.name + '必须填写'
                isRequired = !isRequired
              }
            }
          }
        } else {
          moduleObj.rules = []
        }
        if (isRequired) {
          const rule = {
            required: true,
            message: moduleObj.name + '必须填写',
          }
          moduleObj.rules.push(rule)
        }
      }
      if (obj.disable !== 'none') {
        // 禁用
        if (obj.disable === 'true') {
          moduleObj.options.disabled = true
        } else if (obj.disable === 'false') {
          moduleObj.options.disabled = false
        }
      }
      if (obj.hidden !== 'none') {
        // 隐藏
        if (obj.hidden === 'true') {
          moduleObj.options.hidden = true
        } else if (obj.hidden === 'false') {
          moduleObj.options.hidden = false
        }
      } else if (!fixHiddenDom) {
        moduleObj.options.hidden = false
      }
      // 红色高亮
      if (obj.stress === 'true') {
        moduleObj.options.stress = true
      } else if (obj.stress === 'false') {
        moduleObj.options.stress = false
      }

      // 附件签章
      if (obj.fileSign === 'true') {
        moduleObj.options.sign = true
      } else {
        moduleObj.options.sign = false
      }
      // 处理初始化值
      if (obj.initial && obj.initial !== 'null') {
        this.nodeInitDefaultValue(moduleObj, obj.initial, currentUser)
      }
    }
  }

  /**
   * 节点初始化，设置初始值
   * @param moduleObj
   * @param defaultValue
   */
  static nodeInitDefaultValue(moduleObj, defaultValue, currentUser) {
    if (typeof currentUser !== 'undefined' && currentUser) {
      moduleObj.options.defaultValue = currentUser[defaultValue]

      // 初始化当前组织机构
      if (moduleObj.type === 'organization' && defaultValue === 'currentOrg') {
        moduleObj.options.initCurOrgCode = currentUser.organizationCode
        // 初始化当前组织机构的机构组件-需要配置可选任一层级，以免出错
        moduleObj.options.checkStrictly = true
        generateUtils.getCascaderOptions(moduleObj)
      }

      if (defaultValue === 'applyTime' || defaultValue === 'realName') {
        moduleObj.options.value = currentUser[defaultValue]
      }
    }
  }

  /**
   * 动态隐藏组件
   * @param shList
   * @param config
   * @param list
   */
  static hiddenShowDomList(shList, config, list, models, sonformModel) {
    for (let i = 0; i < list.length; i++) {
      if (list[i].type === 'grid') {
        list[i].columns.forEach(item => {
          this.hiddenShowDomList(shList, config, item.list, models)
        })
      } else if (list[i].type === 'sonform') {
        if (formUtils.arrayContainsStr(shList, list[i].model)) {
          this.hiddenShowDom(list[i], config, list[i].model, models)
        }
        this.hiddenShowDomList(
          shList,
          config,
          list[i].list,
          models,
          list[i].model
        )
      } else if (list[i].type === 'comment') {
        if (formUtils.arrayContainsStr(shList, list[i].model)) {
          this.hiddenShowDom(list[i], config, list[i].model, models)
        }
        this.hiddenShowDomList(
          shList,
          config,
          list[i].list,
          models,
          list[i].model
        )
      } else if (formUtils.arrayContainsStr(shList, list[i].model)) {
        // 找到对应字段
        this.hiddenShowDom(list[i], config, list[i].model, models, sonformModel) // 具体组件配置
      }
    }
  }

  /**
   * 动态显示组件
   * @param moduleObj
   * @param config
   */
  static hiddenShowDom(moduleObj, config, model, models, sonformModel) {
    // 可能需要做更具体的操作 -- 必填时处理方式可能改变
    if (moduleObj && config) {
      // 值置空在前
      let value = ''
      const type = moduleObj.type
      if (type === 'address') {
        value = { inputValue: '', selectValue: [] }
      }
      // 赋值在后
      if (moduleObj.options.defaultValue) {
        value = moduleObj.options.defaultValue
      }
      if (moduleObj.options.value) {
        value = moduleObj.options.value
      }
      if (config === 'show') {
        // 显示
        if (type !== 'divider' && type !== 'swtext' && type !== 'button') {
          if (type === 'checkbox' || type === 'file' || type === 'imgupload') {
            if (!Array.isArray(value)) {
              value = []
            }
          }
          if (model.indexOf('sonform') > -1) {
            value = models[model]
          }
        }
        moduleObj.options.hidden = false
      } else if (config === 'hidden') {
        // 隐藏
        if (type !== 'divider' && type !== 'swtext' && type !== 'button') {
          value = ''
          if (
            type === 'checkbox' ||
            type === 'file' ||
            type === 'sonform' ||
            type === 'page'
          ) {
            if (!Array.isArray(value)) {
              value = []
            }
          }
        }
        moduleObj.options.hidden = true
      }
      if (type !== 'divider' && type !== 'swtext' && type !== 'button') {
        this.setValueToModels(null, model, value, models, sonformModel, config)
        bus.$emit('changeModels', models)
      }
    }
  }

  /**
   * 子表单动态隐藏组件
   * @param shList
   * @param config
   * @param lineRow
   */
  static sonHiddenShowDomList(shList, config, lineRow, models) {
    if (lineRow && lineRow.fields) {
      if (shList && shList.length > 0) {
        const length = shList.length
        for (let i = 0; i < length; i++) {
          if (
            shList[i] &&
            Object.prototype.hasOwnProperty.call(lineRow.fields, shList[i])
          ) {
            this.hiddenSonShowDom(
              lineRow.fields[shList[i]],
              config,
              shList[i],
              models
            )
          }
        }
      }
    }
  }

  /**
   * 动态显示子表单组件
   * @param moduleObj
   * @param config
   */
  static hiddenSonShowDom(moduleObj, config, model, models) {
    if (moduleObj && config) {
      if (config === 'show') {
        // 显示
        moduleObj.hidden = false
      } else if (config === 'hidden') {
        // 隐藏
        const type = moduleObj.type
        if (type !== 'divider' && type !== 'swtext' && type !== 'button') {
          this.setValueToModels(null, model, null, models)
        }
        moduleObj.hidden = true
      }
    }
  }

  /**
   * 动态禁用组件
   * @param shList
   * @param config
   * @param list
   */
  static disabledDomList(shList, config, list) {
    for (let i = 0; i < list.length; i++) {
      if (list[i].type === 'grid') {
        list[i].columns.forEach(item => {
          this.disabledDomList(shList, config, item.list)
        })
      } else if (list[i].type === 'sonform') {
        this.disabledDomList(shList, config, list[i].list)
      } else if (formUtils.arrayContainsStr(shList, list[i].model)) {
        // 找到对应字段
        this.disabledDom(list[i], config) // 具体组件配置
      }
    }
  }

  /**
   * 禁用组件
   * @param moduleObj
   * @param config
   */
  static disabledDom(moduleObj, config) {
    // 可能需要做更具体的操作 -- 必填时处理方式可能改变
    if (moduleObj && config) {
      if (config === 'disabled') {
        // 禁用
        moduleObj.options.disabled = true
      } else if (config === 'undisabled') {
        // 正常显示
        moduleObj.options.disabled = false
      }
    }
  }

  /**
   * 子表单动态禁用组件
   * @param shList
   * @param config
   * @param lineRow
   */
  static sonDisabledDomList(shList, config, lineRow) {
    if (lineRow && lineRow.fields) {
      if (shList && shList.length > 0) {
        const length = shList.length
        for (let i = 0; i < length; i++) {
          if (
            shList[i] &&
            Object.prototype.hasOwnProperty.call(lineRow.fields, shList[i])
          ) {
            this.disabledSonDom(lineRow.fields[shList[i]], config)
          }
        }
      }
    }
  }

  /**
   * 动态禁用子表单组件
   * @param moduleObj
   * @param config
   */
  static disabledSonDom(moduleObj, config) {
    if (moduleObj && config) {
      if (config === 'disabled') {
        // 禁用
        moduleObj.disabled = false
      } else if (config === 'undisabled') {
        // 正常显示
        moduleObj.disabled = true
      }
    }
  }

  /**
   * 根据model  从 dataList(组件列表) 获取数据
   * @param model
   * @param dataList
   */
  static getValueFromList() {
    // 迭代  组件列表 修改  组件信息   隐藏 或者展示  等等
  }

  /**
   * 根据model  从 models 获取数据
   * @param model
   * @param models
   */
  static getValueFromModels(index, model, models) {
    // 判断是否  undefined  然后再 迭代  目前分为两层    第一层   && 表单层
    let value = models[model]
    if (typeof value !== 'undefined' && value !== 'undefined') {
      // 直接获取到值
      return { value: value, status: '200' }
    } else {
      // 迭代循环   ------------------------------------------------------------------ 子表单这里有问题
      let x = ''
      for (x in models) {
        if (x.indexOf('sonform_colorful_egg') > -1) {
          value = models[x][model]
          if (typeof value !== 'undefined' && value !== 'undefined') {
            // 直接获取到值
            return { value: value, status: '200' }
          }
        }
      }
    }
    return { value: 'unKnow Info', status: '500' } // 表示未知信息
  }

  /**
   * 根据model  往 models 设置数据
   * @param index  如果有值，则表示是子表单
   * @param model  key
   * @param value  值
   * @param models
   */
  static setValueToModels(index, model, value, models, sonformModel, config) {
    if (typeof value === 'undefined' || value === 'undefined') {
      // 直接获取到值
      value = null
    }
    try {
      if (sonformModel) {
        if (config === 'show') {
          return
        }
        const sonForm = models[sonformModel] || []
        sonForm.forEach(item => {
          item[model] = value
        })
      } else {
        models[model] = value
      }
    } catch (e) {
      console.log(e)
    }
  }
}
